import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  Client,
  Location,
  PaginatedturbineResultsSideloadList,
  PatchedTechnicianTurbine,
  Turbine,
  TurbineRetrieve,
} from "../../app/generated-axios-client";

export type SideloadedTurbineInfo = {
  client: Record<string, Client>;
  location: Record<string, Location>;
};

export type TurbinePatchPayload = {
  id?: string;
  data: PatchedTechnicianTurbine;
};

export interface TurbineState {
  turbine: TurbineRetrieve | null;
  list: PaginatedturbineResultsSideloadList;
  sideload: SideloadedTurbineInfo | null;
}

const initialState: TurbineState = {
  turbine: null,
  list: {
    "pagination": {
      "total_items": 0,
      "total_pages": 0,
      "current_page": 0,
      "per_page": 0,
    },
    "results": {
      "turbines": [],
      "client": [],
      "location": [],
    },
  },
  sideload: null,
};

export const turbineSlice = createSlice({
  name: "turbine",
  initialState,
  reducers: {
    addOrUpdateTurbine: (state, action: PayloadAction<Turbine>) => {},
    storeTurbine: (state, action: PayloadAction<TurbineRetrieve>) => {
      state.turbine = action.payload;
    },
    removeTurbine: (state, action) => {
      state.turbine = null;
    },
    deleteTurbine: (_state, _action: PayloadAction<string>) => {},
    turbineEdit: (_state, _action: PayloadAction<TurbinePatchPayload>) => {},
    clearTurbines: () => {
      return initialState;
    },
    addTurbineSimpleList: (
      state,
      action: PayloadAction<PaginatedturbineResultsSideloadList>
    ) => {
      state.list = action.payload;
    },
    addTurbineList: (
      state,
      action: PayloadAction<PaginatedturbineResultsSideloadList>
    ) => {
      state.list = action.payload;
    },
    addTurbineSideload: (state, action: PayloadAction<SideloadedTurbineInfo>) => {
      state.sideload = action.payload;
    },
    getTurbineWorkOrders: (_state, _action: PayloadAction<string>) => {},
    getTurbineBlades: (_state, _action: PayloadAction<string>) => {},
  },
});

export const turbineActions = turbineSlice.actions;
export default turbineSlice.reducer;
